/**
 * Plan name → backend plan_type. Must match bos_sysadmin.subscription_plan.plan_type:
 * 1 Freemium/Explorer · 2 Starter/Verifier · 3 Basic/Checker · 4 Pro/Protector ·
 * 5 Business/Guardian · 6 Enterprise/Shield. Tier premium = 4–6.
 * The server resolves the plan from the DB anyway; this value is only a hint.
 */
const PLAN_TYPE_BY_NAME: ReadonlyArray<[needle: string, planType: number]> = [
  ['enterprise', 6], ['business', 5], ['pro', 4], ['basic', 3], ['starter', 2], ['free', 1],
];

export function planTypeFromName(name: string): number {
  const n = (name || '').toLowerCase();
  for (const [needle, planType] of PLAN_TYPE_BY_NAME) if (n.includes(needle)) return planType;
  return 1;
}
